module.exports = "/_next/static/images/90a8d8206e94c32b722a2733d5c4e12a-logo-valor-investe.png";